import { ref } from 'vue'
import { getPermissionNamesFromStorage } from '@/utils/rbac'

/** 全局响应式权限名（MainLayout GET /user 后同步，供 v-permission / useRbac） */
export const rbacPermissionNames = ref(getPermissionNamesFromStorage())

/** 更新全局权限缓存（侧栏、指令、路由守卫共用数据源） */
export function syncRbacPermissionNames (names) {
  rbacPermissionNames.value = Array.isArray(names) ? [...names] : []
}
